import React from 'react';
import { componentService } from 'js/services/component.service';

export const ToggleBalance = React.lazy(() => import(/* webpackChunkName: "toggle-balance" */ './ToggleBalance'));

// <hub2-toggle-balance></hub2-toggle-balance>
componentService.registerWebContentComponents({ ToggleBalance });
